import ssctBnbCakeLp from "../abis/development/ssctBnb/cakeLp";

const host = "https://bscscan.com/address";

export default [
  {
    name: "SSCT-BNB Cake LP",
    type: "bnb",
    contractAddress: "0x75c2214a0b3067c36d8896f20dd8a350fe029cb8",
    minApr: 159,
    abi: ssctBnbCakeLp.abi,
    url: `${host}/0x75c2214a0b3067c36d8896f20dd8a350fe029cb8`,
    decimals: 18,
  },
];
